export const signedState = {
  signed: "Signed",
  unsigned: "Unsigned"
};
